import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import LogoImage from '../images/wickidcool-logo.png'


const Container = styled.div`
  width: 100%;
  background: rgba(121, 164, 91, 0.37);
  
  h2 {
    text-align: center;
    font-size: 32px;
    padding-bottom: 0;
  }
  
  h5 {
    font-size: 16px;
    text-align: center;
  }
`

const ContentContainer = styled.div`
  display: flex;
`

const AddressContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  padding: 0 0 0 50px;
  font-size: 24px;
  border-right: solid;
  float: left;
`

const SocialContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  padding: 0 0 0 50px;
  font-size: 24px;
  border-right: solid;
  float: left;
`

const ContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  padding: 0 0 0 50px;
  font-size: 24px;
  float: left;
`

const Footer = ({ siteTitle }) => (
  <Container>
    <h2>Contact Us!</h2>

    <ContentContainer>
      <AddressContainer>
        Wickidcool Software LLC <br />
        N62W23388 Silver Spring Drive <br />
        Unit 202 <br />
        Sussex, WI 53089
      </AddressContainer>

      <SocialContainer>
        <div>
          <i className="fa fa-facebook-square" /> @wickidcool
        </div>
        <div>
          <i className="fa fa-linkedin-square" /> Wickidcool Software
        </div>
      </SocialContainer>

      <ContactContainer>
        <div>
          <i className="fa fa-phone" /> (414) 614 - 3623
        </div>
        <div>
          <i className="fa fa-envelope-o" /> info@wickidcool.com
        </div>
      </ContactContainer>
    </ContentContainer>

    <h5>Wickidcool Software LLC © {new Date().getFullYear()}</h5>
  </Container>
)

export default Footer
